<template>
    <div>
        <div class="container__suggestion">
            <div class="card__suggestion">
                <div class="card__header__suggestion mb-4">
                    <span>Ensemble, améliorons le service Nsia Assurances</span>
                </div>
                <div class="card__body__suggestion">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>Nom</label>
                                <input v-model="form.last_name" type="text" class="form-control">
                                <div v-if="errors.last_name" style="color: red">{{ errors.last_name[0] }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>Prénom(s)</label>
                                <input v-model="form.first_name" type="text" class="form-control">
                                <div v-if="errors.first_name" style="color: red">{{ errors.first_name[0] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>Email</label>
                                <input v-model="form.email" type="text" class="form-control">
                                <div v-if="errors.email" style="color: red">{{ errors.email[0] }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label class="form-label">Téléphone</label>
                                <div class="input-group input-group-merge">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.4999 12.6901V14.9401C16.5008 15.1489 16.458 15.3557 16.3743 15.5471C16.2907 15.7385 16.1679 15.9103 16.014 16.0515C15.8601 16.1927 15.6784 16.3002 15.4805 16.3671C15.2826 16.434 15.073 16.4589 14.8649 16.4401C12.5571 16.1893 10.3402 15.4007 8.39245 14.1376C6.58032 12.9861 5.04395 11.4497 3.89245 9.63757C2.62493 7.68098 1.83613 5.45332 1.58995 3.13507C1.57121 2.92767 1.59586 2.71864 1.66233 2.52129C1.72879 2.32394 1.83563 2.14259 1.97602 1.98879C2.11642 1.83499 2.2873 1.7121 2.47779 1.62796C2.66828 1.54382 2.87421 1.50027 3.08245 1.50007H5.33245C5.69643 1.49649 6.04929 1.62538 6.32527 1.86272C6.60125 2.10006 6.78151 2.42966 6.83245 2.79007C6.92742 3.51012 7.10354 4.21712 7.35745 4.89757C7.45836 5.16602 7.4802 5.45776 7.42038 5.73823C7.36056 6.01871 7.2216 6.27616 7.01995 6.48007L6.06745 7.43257C7.13512 9.31023 8.68979 10.8649 10.5675 11.9326L11.5199 10.9801C11.7239 10.7784 11.9813 10.6395 12.2618 10.5796C12.5423 10.5198 12.834 10.5417 13.1024 10.6426C13.7829 10.8965 14.4899 11.0726 15.21 11.1676C15.5743 11.219 15.907 11.4025 16.1448 11.6832C16.3827 11.9639 16.5091 12.3223 16.4999 12.6901Z" stroke="#4B4B4B" stroke-opacity="0.65" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>&nbsp; 228
                                        </span>
                                    </div>
                                    <input v-model="form.phone" class="form-control" type="number" />
                                </div>
                                <div v-if="errors.phone" style="color: red">{{ errors.phone[0] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>Indiquez le produit concerné</label>
                                <select v-model="form.product_id" class="form-control">
                                    <option value="">Selectionner</option>
                                    <option value="1">Assurance Auto</option>
                                    <option value="2">Assurance Multirisque Habitation</option>
                                    <option value="3">Assurance Voyage</option>
                                </select>
                                <div v-if="errors.product_id" style="color: red">{{ errors.product_id[0] }}</div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>Objet</label>
                                <input type="text" v-model="form.title" class="form-control">
                                <div v-if="errors.title" style="color: red">{{ errors.title[0] }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Laissez-nous votre suggestion ci-dessous</label>
                                <textarea rows="3" class="form-control" v-model="form.description"></textarea>
                                <div v-if="errors.description" style="color: red">{{ errors.description[0] }}</div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="btn btn-primary" @click="createSuggestion()" :class="loading ? 'disabled' : ''">Envoyer</div>
                </div>
            </div>
        </div>
        <div class="payment__info">
            <div class="payment__info--text">Moyens de paiement acceptés</div>
            <div class="payment__widget">
                <img :src="$assets('images/payment.png')" width="140" alt="payment">
            </div>
        </div>
        <div class="voyage__info">
            <div class="happy__young" :style="`background: url(${$assets('images/young.png')}) no-repeat center;background-size: cover;`"></div>
            <div class="hire__me">
                <div class="background__info">
                    <div class="svg__hire">
                        <svg width="188" height="188" viewBox="0 0 188 188" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z" fill="#E8EFFF"/>
                        </svg>
                    </div>
                    <div class="hire__me--text">Contactez-nous</div>
                    <div class="hire__me--description">
                        Si vous avez des questions ou rencontrez une difficulté, contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
                    </div>
                    <div class="hire__me--button">
                        <button class="btn btn-secondary">Parler à un expert</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { api } from '../../helpers/shared'
export default {
    props:{
        sug:{
            type: String,
            default: () => ''
        }
    },
    data: () => ({
        form: {
            phone: '',
            email: '',
            first_name: '',
            last_name: '',
            product_id: '',
            description: '',
            title: ''
        },
        errors: [],
        loading: false,
    }),
    mounted() {
        this.form = { ...JSON.parse(this.sug) }
        //console.log("Valeur de this.sug:",this.sug)
    },
    methods:{
        createSuggestion(){
            this.loading = true;
            axios.post(api('suggestion'), this.form)
                .then((response) => {
                    this.loading = false;
                    this.errors = [];
                    if (response.data.status){
                        this.$toasted.global.all({message: "Merci pour votre suggestion"});
                        setTimeout(() => {
                            window.location.reload()
                        }, 500)
                    }else this.$toasted.global.error();
                }).catch((error) => {
                this.loading = false;
                if (error.response.status === 422){
                    this.errors = error.response.data.errors
                }else this.$toasted.global.error({message: "Vous devez vous connecter pour procéder à cette opération"})
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .container__suggestion{
        margin: 20px 25% 20px 25%;
        .card__suggestion{
            background: #FFFFFF;
            border-radius: 4px;
            height: auto;
            padding: 24px;
        }
    }
    .card__header_suggestion span{
        font-weight: bold;
        font-size: 24px;
        color: #000000;
    }
    @media only screen and (max-width: 730px) {
        .container__suggestion{
            margin: 20px 5% 20px 5% !important;
        }
    }
</style>
